export default __webpack_public_path__ + "static/media/2.c8b0cc64.png";